import {createBrowserHistory} from 'history';

const ownHistory = createBrowserHistory();

export default ownHistory;
